import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrej Sharapov
 * id 1F5EB171-8FDB-4C8A-B748-6B4EAF022243
 * name message-check-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-check-outline.svg
 * tags
 */
export const MessageCheckOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M10.47 14L7 10.5L8.4 9.09L10.47 11.17L15.6 6L17 7.41L10.47 14Z" /></>, 'MessageCheckOutlineIcon');
export default MessageCheckOutlineIcon